import { SmilingFace } from 'app/components/icons'
import styles from './styles.module.scss'

const EmojiSender = ({ toggleIcons, showIcons }) => {
  const openPicker = (e) => {
    e.preventDefault()
    toggleIcons()
  }

  return (
    <div className={styles.emoji_sender_wrapper}>
      <button data-show-icons={!!showIcons} onClick={(e) => openPicker(e)}>
        <SmilingFace className={styles.emoji_input_icon} color="#000" />
      </button>
    </div>
  )
}

export default EmojiSender
